import { Browser } from '@src/infrastructure/browser';
import { ErrorHandler } from '@src/infrastructure/errorHandler';
import { CartStore } from '@src/infrastructure/storage/cartStore';
import { ServerSettings } from '@src/infrastructure/serverSettings';

export class CartViewModel {
    private readonly cartStore: CartStore;
    private readonly errorHandler: ErrorHandler;
    private readonly browser: Browser;

    constructor(serverSettings: ServerSettings) {
        this.cartStore = new CartStore();
        this.browser = new Browser();
        this.errorHandler = new ErrorHandler(serverSettings);
    }

    private async initialize() {
        const cartState = await this.cartStore.get();
    }
}